import { AppointmentCancellationReason } from '@server/prisma-generated/enums';
import {
    Baby,
    Ban,
    Building2,
    CalendarClock,
    CircleAlert,
    Ellipsis,
    Hospital,
    ShieldAlert,
    Thermometer,
    TrainFront,
    UserX,
    Wallet,
    type LucideIcon,
} from 'lucide-react';

export const CANCELLATION_REASON_LABELS: Record<AppointmentCancellationReason, string> = {
    [AppointmentCancellationReason.SCHEDULING_CONFLICT]: 'Terminkonflikt - Beruf, Familie, Betreuung',
    [AppointmentCancellationReason.HEALTH]: 'Gesundheitlich verhindert (krank, anderweitige medizinische Gründe )',
    [AppointmentCancellationReason.NO_LONGER_NEEDED]: 'Termin nicht mehr nötig / Kein Behandlungswunsch mehr',
    [AppointmentCancellationReason.BOOKING_ERROR]: 'Fehlerhafte Buchung (z.B. falsche Leistung, Discount Code vergessen)',
    [AppointmentCancellationReason.OTHER_CLINIC]: 'Termin bei anderer Klinik gebucht',
    [AppointmentCancellationReason.ARRIVAL]: 'Anreise (Zug, Stau, Verspätung usw.)',
    [AppointmentCancellationReason.PRACTITIONER_UNAVAILABLE]: 'Nicht bei Wunschbehandler/in eingebucht bzw. Wunschbehandler/in nicht verfügbar',
    [AppointmentCancellationReason.TREATMENT_ANXIETY]: 'Unsicherheit oder Angst vor der Behandlung',
    [AppointmentCancellationReason.PREGNANCY_OR_BREASTFEEDING]: 'Mögliche Schwangerschaft oder Stillzeit',
    [AppointmentCancellationReason.FINANCIAL]: 'Finanzielle Gründe',
    [AppointmentCancellationReason.CANCELLED_BY_CLINIC]: 'Absage durch Klinik',
    [AppointmentCancellationReason.OTHER]: 'Sonstiges',
};

export const CANCELLATION_REASON_ICONS: Record<AppointmentCancellationReason, LucideIcon> = {
    [AppointmentCancellationReason.SCHEDULING_CONFLICT]: CalendarClock,
    [AppointmentCancellationReason.HEALTH]: Thermometer,
    [AppointmentCancellationReason.NO_LONGER_NEEDED]: Ban,
    [AppointmentCancellationReason.OTHER_CLINIC]: Building2,
    [AppointmentCancellationReason.ARRIVAL]: TrainFront,
    [AppointmentCancellationReason.PRACTITIONER_UNAVAILABLE]: UserX,
    [AppointmentCancellationReason.TREATMENT_ANXIETY]: ShieldAlert,
    [AppointmentCancellationReason.PREGNANCY_OR_BREASTFEEDING]: Baby,
    [AppointmentCancellationReason.FINANCIAL]: Wallet,
    [AppointmentCancellationReason.BOOKING_ERROR]: CircleAlert,
    [AppointmentCancellationReason.CANCELLED_BY_CLINIC]: Hospital,
    [AppointmentCancellationReason.OTHER]: Ellipsis,
};

/** Clinic-side cancellations use the CALLED_OFF status instead, so they are not selectable here. */
const NON_SELECTABLE_CANCELLATION_REASONS: AppointmentCancellationReason[] = [
    AppointmentCancellationReason.CANCELLED_BY_CLINIC,
];

export const CANCELLATION_REASON_OPTIONS = (Object.entries(CANCELLATION_REASON_LABELS) as Array<
    [AppointmentCancellationReason, string]
>).filter(([value]) => !NON_SELECTABLE_CANCELLATION_REASONS.includes(value));

/** All reasons in the same order as cancellations; CANCELLED_BY_CLINIC is selectable when moving. */
export const MOVE_REASON_OPTIONS = (Object.entries(CANCELLATION_REASON_LABELS) as Array<
    [AppointmentCancellationReason, string]
>).map(([value, label]): [AppointmentCancellationReason, string] => [
    value,
    value === AppointmentCancellationReason.CANCELLED_BY_CLINIC ? 'Von Kalia verschoben' : label,
]);

export const MOVE_REASONS_REQUIRING_NOTE: AppointmentCancellationReason[] = [
    AppointmentCancellationReason.CANCELLED_BY_CLINIC,
    AppointmentCancellationReason.OTHER,
];
